module.exports = __webpack_public_path__ + "img-dashboard/register/player-circle-blue.b90cd95f.png";